import { memo, useMemo, useState, useCallback, useRef } from "react";
import { ReportContent, ReportHeader, ReportSearch } from "@/components/tableDrawer";
import "./style.css";
import useNavs from "@/hooks/useNavs";
import { useSelectedTableItems } from "@/components/tableDrawer/reportContent/Hooks/useSelectedTableItems";
import { GetAllAMOrders } from "@/api/endpoints/AccountManager";
import TableHeader from "../shared/RowsCells/TableHeader";
import Status from "../shared/RowsCells/Status/Status";
import { useTranslation } from "react-i18next";
import HospitalPopup from "@/components/popups/HospitalPopup/HospitalPopup";
import moment from "moment";
import { MISSING_DATA_STATUS,  PATIENT_REQUEST_STATUS_MAP } from "@/data/status";
import ActionBtn from "../shared/ActionBtn/ActionBtn";
import MissingDataPopup from "@/components/popups/MissingDataPopup";

const dateFormatter = (date) => {
  if(!date) return "--";
  return moment(date).format("YYYY-MM-DD HH:mm A");
}

const AccountManagerMedicalRequests = () => {
  const { t } = useTranslation();
  const hospitalRef = useRef(null);
  const missingDataRef = useRef(null)

  const { AccountManagerNav } = useNavs();
  const { selectedItems, handleSelected } = useSelectedTableItems();
  const [providerIds, setProviderIds] = useState([])
  const [PatientId, setPatientId] = useState(null)


  const viewPopup = (id)=>{
    setPatientId(id)
    missingDataRef?.current?.click()
  }

  const viewRequestDetails = useCallback((original) => AccountManagerNav(`medical-reports/${original?.brokerPatientId}`), [AccountManagerNav]);
  const viewQuotationDetails = useCallback((original) => AccountManagerNav(`medical-requests/${original?.brokerPatientId}/${original?.medicalOrderId}`), [AccountManagerNav]);
  const columns = useMemo(() => ([
      { Header: "ID", accessor: "brokerPatientId", canSearch: false, visible: true },
      { Header: "patientName", accessor: "patientName", canSearch: true, visible: true },
      { Header: "specialty", accessor: "specialty",canSearch: true, visible: true, Cell:({row:{original}})=>(<span className="specialty">{original?.category} <br /> <span className="sub-specialty">{original?.subCategory}</span></span>) },
      { Header: "brokerName", accessor: "brokerName", canSearch: true, visible: true },
      { Header: "request-date", accessor: "orderDate", type: "Date", canSearch: true, visible: true},
      { Header: "last-activity", accessor: "orderLastActivityAt", type: "Date", canSearch: false, visible: true ,
        Cell:({row:{original}})=>(
        <span className="last-activity">{dateFormatter(original?.orderLastActivityAt)}</span>
      )},
      {
        Header: "status",
        canSearch: true,
        visible: true,
        type: "DropDown",
        isMulti:false,
        options: PATIENT_REQUEST_STATUS_MAP,
        Cell: ({ row: { original } }) =>
          <Status status={{ name: t(original?.orderStatus), id: original?.orderStatusId }} />
      },
      {
        Header: "action",
        Cell: ({ row: { original } }) => (
          <>
          <ActionBtn
              isRender={original?.orderStatusId == 2}
              tooltipName={"process-request"}
              onClick={() => viewQuotationDetails(original)}
              reqAction="canGet"
              icon={"uis:process"}
            />
         <ActionBtn
              isRender
              tooltipName={"patient-case-file"}
              onClick={() => viewRequestDetails(original)}
              reqAction="canGet"
              icon={"mdi:eye"}
            />
         <ActionBtn
              isRender={original.missingDataStatus !== MISSING_DATA_STATUS.AskingForMissingData}
              tooltipName={"missing-data"}
              onClick={() => viewPopup(original?.patientId)}
              reqAction="canGet"
              icon={"akar-icons:question-fill"}
            />
            </>
        ),
      },
    ]), [viewRequestDetails, viewQuotationDetails, t])



  return (
    <>
    <MissingDataPopup  modalID={missingDataRef} name="missing-data" title="Missing Data" PatientId={PatientId} />
      <HospitalPopup hospitalRef={hospitalRef} providerIds={providerIds} setProviderIds={setProviderIds} selectedItems={selectedItems} />
      <TableHeader selectedItems={selectedItems} setProviderIds={setProviderIds} hospitalRef={hospitalRef}  />
      <ReportContent  handleSelected={handleSelected} tableAPI={GetAllAMOrders} columns={columns} stickyActions={true}>
        <ReportHeader title={"Medical Requests Pipeline"}>
          <ReportSearch />
        </ReportHeader>
      </ReportContent>
    </>
  );
};

export default memo(AccountManagerMedicalRequests);
